/**
 * Enum representing different franchise roles within the system.
 */
export enum FranchiseRole {
  /** Admin role with the highest level of access (value: 1). */
  ADMIN = 1,

  /** Admin role with general administrative privileges (value: 2). */
  MANAGER = 2,

  /** Manager role with elevated permissions (value: 3). */
  USER = 3,

  /** Support role with limited permissions for assistance tasks (value: 4). */
  DELIVERY = 4,
}